<template>
  <div class="spotlight relative">
    <div
      class="spotlight__image"
      v-touch="{
        up: () => swipe(true),
        down: () => swipe(false),
      }"
    >
      <img v-if="currentIndex == 0" src="../../assets/mobile/spotlight.gif" />
      <img v-if="currentIndex == 1" src="../../assets/mobile/spotlight_1.gif" />
      <img v-else src="../../assets/mobile/spotlight_2.gif" />
    </div>

    <div class="spotlight__content full-width absolute">
      <div class="display-flex justify-space-between align-center">
        <img
          :src="require('@/assets/ys_logo_primary-black.svg')"
          width="100"
          @click="$router.push('/')"
        />
        <div class="camera">
          <img
            src="../../assets/mobile/icon/camera.svg"
            width="19"
            height="19"
          />
        </div>
      </div>

      <div class="spotlight__action display-flex flex-column align-center">
        <div
          class="display-flex flex-column justify-center mb-3"
          @click="isSend = true"
        >
          <img
            src="../../assets/mobile/icon/message.svg"
            width="19"
            height="19"
            class="mb-1"
          />
          <span class="text-poppins-14 text-white">23</span>
        </div>
        <div
          class="display-flex flex-column justify-center mb-3"
          @click="isComment = true"
        >
          <img
            src="../../assets/mobile/icon/f-chat.svg"
            width="20"
            height="20"
            class="mb-1"
          />
          <span class="text-poppins-14 text-white">1.2k</span>
        </div>
        <div class="display-flex flex-column justify-center mb-3">
          <img src="../../assets/mobile/icon/dot.svg" width="24" height="24" />
        </div>
        <div class="display-flex flex-column justify-center">
          <img src="../../assets/mobile/music.svg" width="34" height="34" />
        </div>
      </div>

      <div
        class="display-flex justify-space-between align-center spotlight__user"
      >
        <div class="display-flex align-center gap-8">
          <img src="../../assets/mobile/user.svg" width="60" height="60" />
          <div>
            <div class="display-flex gap-4 align-center">
              <span class="text-poppins-18 text-white"> Salva </span>
              <img
                src="../../assets/mobile/icon/check-circle.svg"
                class="max-full-width"
              />
            </div>
            <div class="text-poppins-15 text-white">12,392 views</div>
          </div>
        </div>
        <div class="btn-follow display-flex justify-center align-center">
          <div class="text-poppins-13 text-black font-weight-600">Follow</div>
        </div>
      </div>

      <Footer />
    </div>

    <v-bottom-sheet v-model="isComment" hide-overlay>
      <v-list class="px-4">
        <v-subheader class="text-inter-14 font-weight-600 mb-3 justify-center">
          Comments
        </v-subheader>
        <div class="display-flex gap-10 mb-5 pb-5">
          <img
            src="../../assets/mobile/notification_2.png"
            :width="44"
            :height="44"
            class="rounded"
          />
          <div>
            <div class="text-inter-14">
              <span class="font-weight-600"> superman10 </span>
              <span class="font-weight-500 text-grey-3">12s</span>
            </div>
            <div class="text-inter-14 font-weight-500">
              I really want to do those things a thing when we we see a thing to
              do a thing when really really see the thing!
            </div>
          </div>
        </div>

        <div class="display-flex align-center gap-10 my-5 pt-5">
          <img
            src="../../assets/mobile/notification_2.png"
            :width="44"
            :height="44"
            class="rounded"
          />
          <input
            type="text"
            class="input-comment full-width pa-2"
            placeholder="Say something!"
          />
        </div>
      </v-list>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="isSend" hide-overlay>
      <v-list class="px-4">
        <div class="display-flex align-center input-search px-2 my-4">
          <img
            src="../../assets/mobile/icon/search.svg"
            width="20"
            height="20"
          />
          <input
            type="text"
            class="full-width px-2 input-search__input"
            placeholder="Search people"
          />
        </div>
        <v-layout row wrap>
          <v-flex d-flex xs4 v-for="i in 4" :key="i" mb-3>
            <div
              class="display-flex flex-column align-center justify-center gap-4"
            >
              <img
                src="../../assets/mobile/notification_2.png"
                :width="44"
                :height="44"
                class="rounded"
              />
              <div class="text-inter-14 font-weight-500">TREV</div>
            </div>
          </v-flex>
        </v-layout>

        <div class="input-send">
          <input
            type="text"
            class="full-width px-2 input-send__input"
            placeholder="Write a message..."
          />
          <v-btn class="input-send__btn text-inter-12 text-white">
            Send seperately
          </v-btn>
        </div>
      </v-list>
    </v-bottom-sheet>
  </div>
</template>

<script>
import Footer from "./components/footer";

export default {
  components: {
    Footer,
  },
  data: () => ({
    isComment: false,
    isSend: false,
    currentIndex: 0,
  }),
  methods: {
    swipe(isDown) {
      if (isDown) {
        this.currentIndex =
          this.currentIndex < 3 ? this.currentIndex + 1 : this.currentIndex;
      } else {
        this.currentIndex =
          this.currentIndex == 0 ? this.currentIndex : this.currentIndex - 1;
      }
      console.log(this.currentIndex, "222222222222222222222222222");
    },
  },
};
</script>

<style lang="scss" scoped>
.spotlight {
  z-index: 10;
  &__image {
    position: fixed;
    z-index: 0;
    bottom: 0px;
    width: 100%;
    left: 0px;
    height: 100%;
    z-index: 1;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &__content {
    z-index: 5;
    height: 100%;
  }
  &__user {
    position: fixed;
    z-index: 5;
    bottom: 70px;
    width: 100%;
    left: 0px;
    height: 81px;
    padding: 16px;
  }
  &__action {
    position: fixed;
    z-index: 5;
    bottom: 140px;
    right: 0px;
    padding: 16px;
  }
}

.btn-follow {
  border-radius: 3px;
  background: #fff;
  width: 59px;
  height: 30px;
}
.camera {
  width: 35px;
  height: 35px;
  background: red;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/.footer {
  background: transparent !important;
}

.input-comment {
  border-radius: 17.5px;
  border: 1px solid rgba(187, 179, 169, 0.31);
  background: #fff;
}

.input-search {
  border-radius: 8px;
  border: 1px solid rgba(114, 132, 148, 0.2);
  background: #f6f6f6;
  &__input {
    border: 0px !important;
    background: #f6f6f6 !important;
    margin: 2px !important;
  }
}

.input-send {
  &__input {
    border: 0px !important;
    height: 70px !important;
  }
  &__btn {
    border-radius: 6px;
    background: #2489ff !important;
    width: 100%;
    margin: 12px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// spotlight.vue?74741dc4